const renderValidationText = (
  info,
  variant,
  validationText,
  linkText,
  link,
  onClick,
) =>
  info
    ? { variant, validation: { validationText, linkText, link, onClick } }
    : {}

export { renderValidationText }
